import React, { Fragment } from 'react';

import {
  FetchProductsCacheKeys,
  OnSelectedProductsSidebarCloseAction
} from '../../../../../../products/productsTypes';
import {
  SelectedProductsListItemLightboxBottomButtonsSelectedProduct,
  SelectedProductsListItemLightboxBottomButtonsProductsSet
} from './SelectedProductsListItemLightboxBottomButtons.types';
import {
  UpdateProductsSetCacheAction,
  FetchProductsSetsCacheKeys
} from '../../../../../../productsSets/productsSetsTypes';
import { IconsEnum } from '../../../../../../../assets/icons/types';

import { DownloadSelectedProductButton } from '../../../../buttons/DownloadSelectedProductButton';
import { DownloadSelectedProductSeparatelyButton } from '../../../../buttons/DownloadSelectedProductSeparatelyButton';
import { SelectedProductsListItemDeleteButton } from '../../../SelectedProductsListItem/components/SelectedProductsListItemDeleteButton';
import { SelectedProductsListItemLightboxFavoriteButton } from '../SelectedProductsListItemLightboxFavoriteButton';

import { CheckPermissions } from '../../../../../../../helpers/CheckPermissions';

import { SelectedProductsPermissions } from '../../../../../selectedProductsConstants';

import { words } from '../../../../../../../locales/keys';

interface SelectedProductsListItemLightboxBottomButtonsProps {
  selectedProduct: SelectedProductsListItemLightboxBottomButtonsSelectedProduct;
  productsSet: SelectedProductsListItemLightboxBottomButtonsProductsSet | null;
  productsCacheKeys?: FetchProductsCacheKeys;
  productsSetCacheKeys?: FetchProductsSetsCacheKeys;
  onSelectedProductsSidebarClose: OnSelectedProductsSidebarCloseAction;
  updateProductsSetCache: UpdateProductsSetCacheAction<SelectedProductsListItemLightboxBottomButtonsProductsSet>;
}

function SelectedProductsListItemLightboxBottomButtons({
  selectedProduct,
  productsSet,
  productsCacheKeys,
  productsSetCacheKeys,
  onSelectedProductsSidebarClose,
  updateProductsSetCache
}: SelectedProductsListItemLightboxBottomButtonsProps) {
  return (
    <Fragment>
      <SelectedProductsListItemDeleteButton
        className="py-2 font-medium inline-flex space-x-1 items-center rounded-md text-gray-800 hover:bg-gray-300 bg-gray-200 px-4 focus:ring-white focus:ring-offset-black"
        i18nText={words.remove}
        onSelectedProductsSidebarClose={onSelectedProductsSidebarClose}
        productsSet={productsSet}
        productsSetCacheKeys={productsSetCacheKeys}
        selectedProduct={selectedProduct}
        updateProductsSetCache={updateProductsSetCache}
      />

      <CheckPermissions
        action={
          SelectedProductsPermissions.READ_SELECTED_PRODUCT_FAVORITE_BUTTON
        }
      >
        <SelectedProductsListItemLightboxFavoriteButton
          selectedProduct={selectedProduct}
          productsCacheKeys={productsCacheKeys}
          productsSetCacheKeys={productsSetCacheKeys}
        />
      </CheckPermissions>

      <CheckPermissions
        action={
          SelectedProductsPermissions.READ_SELECTED_PRODUCTS_DOWNLOAD_BUTTON
        }
      >
        <DownloadSelectedProductButton
          className="py-2 pl-2 pr-2 rounded-md inline-flex items-center whitespace-nowrap text-sm font-medium leading-6 focus:ring-white focus:ring-offset-0 hover:bg-white hover:bg-opacity-10 text-gray-300 hover:text-white"
          icon={IconsEnum.DOWNLOAD_OUTLINE}
          iconClassName="h-6 w-6"
          selectedProductUuid={selectedProduct.uuid}
          tooltipSingleton
          tooltipI18nText={words.download}
        />
      </CheckPermissions>

      <CheckPermissions
        action={
          SelectedProductsPermissions.READ_SELECTED_PRODUCTS_DOWNLOAD_SEPARATELY_BUTTON
        }
      >
        <DownloadSelectedProductSeparatelyButton
          className="py-2 pl-2 pr-2 rounded-md inline-flex items-center whitespace-nowrap text-sm font-medium leading-6 focus:ring-white focus:ring-offset-0 hover:bg-white hover:bg-opacity-10 text-gray-300 hover:text-white"
          dataGa="selected-product-download-separately-button"
          icon={IconsEnum.DOWNLOAD_OUTLINE}
          iconClassName="h-6 w-6"
          selectedProductUuid={selectedProduct.uuid}
          tooltipI18nText={words.download}
          tooltipSingleton
        />
      </CheckPermissions>
    </Fragment>
  );
}

export default SelectedProductsListItemLightboxBottomButtons;
